module.exports = __webpack_public_path__ + "img/eu-3.feb38531.jpg";